import type { SsdUnmappedDealer } from "@/lib/ssdSalesClient";

/** One row per incoming host lot id. Later copies add their sale counts onto the first row. */
export function stackUnmappedLots(rows: readonly SsdUnmappedDealer[]): SsdUnmappedDealer[] {
  const tally = new Map<string, SsdUnmappedDealer>();
  for (const row of rows) {
    const id = row.source_dealer_id.trim();
    if (!id) continue;
    const prior = tally.get(id);
    if (!prior) {
      tally.set(id, { ...row, source_dealer_id: id });
      continue;
    }
    prior.fact_count += row.fact_count;
    if (!prior.source_dealer_name && row.source_dealer_name) prior.source_dealer_name = row.source_dealer_name;
  }
  return [...tally.values()].sort(
    (a, b) => b.fact_count - a.fact_count || a.source_dealer_id.localeCompare(b.source_dealer_id)
  );
}
